(() => {

    const counter = document.getElementById('day-counter');
    const counterMobileWrapper = document.getElementById('counter-mobile')

    if (!counter) return;

    const counterValue = counter.querySelector('.value');


    const ts = parseInt(counter.dataset.ts, 10);
    const getNow = () => Math.floor(new Date().getTime() / 1000);
    const getTimeLeft = () => {
        const now = getNow();
        if (ts - now < 0) return 0;
        return ts - now;
    }

    const lang = document.body.lang || document.html.lang || "de";

    const TRANSLATIONS = {
        en: {
            days: "Days",
            hours: "Hours",
            minutes: "Minutes",
            seconds: "Seconds",
            day: "Day",
            hour: "Hour",
            minute: "Minute",
            second: "Second"
        },
        de: {
            days: "Tagen",
            hours: "Stunden",
            minutes: "Minuten",
            seconds: "Sekunden",
            day: "Tag",
            hour: "Stunde",
            minute: "Minute",
            second: "Sekunde"
        },
        fr: {
            days: "Jours",
            hours: "Heures",
            minutes: "Minutes",
            seconds: "Secondes",
            day: "Jour",
            hour: "Heure",
            minute: "Minute",
            second: "Seconde"
        },
        it: {
            days: "Giorni",
            hours: "Ore",
            minutes: "Minuti",
            seconds: "Secondi",
            day: "Giorni",
            hour: "Ore",
            minute: "Minuti",
            second: "Secondi"
        }
    }

    const STRINGS = TRANSLATIONS[lang] || TRANSLATIONS.de;

    const formatCounterString = (seconds) => {
        const days = Math.floor(seconds / 3600 / 24);
        const hours = Math.floor((seconds - (days * 3600 * 24)) / 3600);
        const minutes = Math.floor((seconds - (days * 3600 * 24) - (hours * 3600)) / 60);
        const sec = Math.floor((seconds - (days * 3600 * 24) - (hours * 3600) - (minutes * 60)));

        const string = [];
        const stringRender = {...STRINGS};

        if (days === 1) {
            stringRender.days = stringRender.day;
        }
        if (hours === 1) {
            stringRender.hours = stringRender.hour;
        }
        if (minutes === 1) {
            stringRender.minutes = stringRender.minute;
        }
        if (sec === 1) {
            stringRender.seconds = stringRender.second;
        }

        if (days > 0) string.push(`${days} ${stringRender.days}`);
        if (hours > 0) string.push(`${hours} ${stringRender.hours}`);
        string.push(`${minutes} ${stringRender.minutes}`);
        string.push(`${sec} ${stringRender.seconds}`);

        return string.join(" ");
    }

    const updateCounter = () => {
        counterValue.textContent = formatCounterString(getTimeLeft());
        counterMobileWrapper.innerHTML = null;
        const counterCopy = counter.cloneNode(true);
        counterCopy.id = "";
        counterMobileWrapper.appendChild(counterCopy);
    };

    updateCounter();
    setInterval(updateCounter, 1000);


})();
